import { toast } from "sonner";
import { api } from "@/lib/api";

export async function downloadFullBackup() {
  try {
    toast.info("Bundling your data — this can take a moment…");
    const blob = await api.exportFullData();
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `stagedoor-export-${new Date().toISOString().slice(0, 10)}.zip`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
    toast.success("Full backup downloaded");
  } catch {
    toast.error("Export failed");
  }
}
